import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=bc9c4562&"
import script from "./TagsComponent.vue?vue&type=script&lang=js&"
export * from "./TagsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports